// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";
import store from "@/store";
const routeParams = {
    unitId: (route, unitId) => {
        return {
            name: consts.routerNames.units.type.xcool.info,
            params: {
                unitId,
                template: 'xcool'
            },
            query: {...route.query}
        }
    },
    fleet: (route, groupId) => {
        return {
            name: consts.routerNames.md.fleet.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    vision: (route, groupId) => {
        groupId = groupId || route?.params?.groupId
        return {
            name: consts.routerNames.md.vision.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    visionCameras: (route, groupId) => {
        groupId = groupId || route?.params?.groupId
        return {
            name: consts.routerNames.md.vision.cameras.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    visionCamerasGroup: (route, groupId) => {
        return {
            name: consts.routerNames?.md?.vision.cameras.groupId.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    visionDriverScorecard: (route) => {
        //groupId = groupId || route?.params?.groupId
        return {
            name: consts.routerNames.md.vision.driverScorecard.main,
            params: {
            },
            query: {...route.query}
        }
    },
    xcool: (route, groupId) => {
        groupId = groupId || route?.params?.groupId
        return {
            name: consts.routerNames.md.xcool.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    xcoolReefers: (route, groupId) => {
        groupId = groupId || route?.params?.groupId
        return {
            name: consts.routerNames.md.xcool.reefers.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    md: (route, groupId) => {
        return {
            name: consts.routerNames.md.main,
            params: {
                groupId
            },
            query: {...route.query}
        }
    },
    xcoolGreenSee: (route, groupId) => {
        return {
            name: consts.routerNames?.md?.xcool?.greenSee?.main,
            params: {
                groupId,
            },
            query: {...route.query}
        }
    },
    unitsWidget: (route, groupId, widget) => {
        return {
            name: consts.routerNames.md.fleet.widget,
            params: {
                widget,
                groupId,
            },
            query: {...route.query}
        }
    },
    greenseeDate: (route, date, dateTo) => {
        let params = {
            date: date || store.getters.getDateToday,
            dateTo,
        }
        return {
            name: consts.routerNames.md.xcool.greenSee.date,
            params,
            query: {...route.query}
        }
    },
    greenseeTrip: (route, tripId, date) => {
        let params = {tripId}
        if(date) params.date = date
        return {
            name: consts.routerNames.md.xcool.greenSee.tripId,
            params,
            query: {...route.query}
        }
    },
    greenseeTripGraph: (route, unitId, timeFrom, timeTo) => {
        unitId = unitId || +route.params?.unitId
        timeFrom = timeFrom || route.params?.timeFrom
        timeTo = timeTo || route.params?.timeTo
        return {
            name: consts.routerNames.md.xcool.greenSee.graph,
            params: {
                ...route.params,
                unitId,
                timeFrom,
                timeTo,
            },
            query: {...route.query}
        }
    },
    greenseeTrack: (route, unitId, timeFrom, timeTo) => {
        unitId = unitId || +route.params?.unitId
        timeFrom = timeFrom || route.params?.timeFrom
        timeTo = timeTo || route.params?.timeTo
        return {
            name: consts.routerNames.md.xcool.greenSee.track,
            params: {
                ...route.params,
                unitId,
                timeFrom,
                timeTo
            },
            query: {...route.query}
        }
    },
    queryFilter: (route, filter) => {
        return {
            name: route.name,
            params: {
                ...route.params
            },
            query: {...filter}
        }
    },
    unitInfo: (route, unitId) => {
        return {
            name: consts.routerNames.units.type.xcool.info,
            params: {
                unitId,
                template: 'xcool',
            },
            query: {}
        }
    },
}
const defaultSetRoute = {
    unitId: (route, router, unitId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' unitId', route);
            return false;
        }
        router.push(routeParams.unitId(route, unitId))
    },
    md: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        router.push(routeParams.md(route, groupId))
    },
    MDFleet: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        router.push(routeParams.fleet(route, groupId))
    },
    MDVision: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        router.push(routeParams.vision(route, groupId))
    },
    xCool: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.xcool+' xCool', route);
            return false;
        }
        router.push(routeParams.xcool(route, groupId))
    },
    driverScorecard: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.driverScorecard+' driverScorecard', route);
            return false;
        }
        router.push(routeParams.driverScorecard(route, groupId))
    },
    xcoolReefers: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.xcool.reefers+' xcoolReefers', route);
            return false;
        }
        router.push(routeParams.xcoolReefers(route, groupId))
    },
    MDVisionCameras: (route, router) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+'MDVisionCameras', route);
            return false;
        }

        router.push(routeParams.visionCameras(route))
    },
    MDVisionCamerasGroup: (route, router, groupId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' MDVisionCamerasGroup', route);
            return false;
        }

        let localeStorageKey = store.getters.getUserStorageKey + '.MDVisionCamerasGroup'
        localStorage.setItem(localeStorageKey, groupId)

        router.push(routeParams.visionCamerasGroup(route, groupId))
    },
    MDVisionDriverScorecard: (route, router) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' MDVisionDriverScorecard', route);
            return false;
        }
        router.push(routeParams.visionDriverScorecard(route))
    },
    unitsWidget: (route, router, widget) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.md.main+' returnToParent', route);
            return false;
        }
        let groupId = route.params.groupId
        router.push(routeParams.unitsWidget(route, groupId, widget))
    },
    greenseeDate(route, router, date, dateTo) {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('groupFilter', route);
            return false
        }
        router.push(routeParams.greenseeDate(route, date, dateTo))
    },
    greenseeTrip(route, router, tripId, date) {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('greenseeTrip', route);
            return false
        }
        router.push(routeParams.greenseeTrip(route, tripId, date))
    },
    greenseeTripGraph(route, router, tripId) {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('greenseeTripGraph', route);
            return false
        }
        router.push(routeParams.greenseeTripGraph(route, tripId))
    },
    greenseeTrack(route, router, unitId, timeFrom, timeTo) {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('greenseeTrip', route);
            return false
        }
        router.push(routeParams.greenseeTrack(route, unitId, timeFrom, timeTo))
    },
    xcoolGreenSee(route, router) {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('greenseeTrip', route);
            return false
        }
        router.push(routeParams.xcoolGreenSee(route))
    },
    queryFilter: (route, router, filter) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('groupFilter', route);
            return false
        }
        router.push(routeParams.queryFilter(route, filter))
    },
    unitInfo: (route, router, uniId) => {
        if(getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.md.main) {
            if (consts.app.$isDevelopment) console.warn('unitInfo', route);
            return false
        }
        router.push(routeParams.unitInfo(route, uniId))
    },
    trackEvent: (route, router, trackEventType, trackEventXid) => {
        if(route.meta?.mainRouteName !== consts.routerNames.tracks.main) {
            if(consts.app.$isDevelopment) console.warn('trackEvent', route);
            return false
        }
        if(consts.app.$isDevelopment) console.log(router, trackEventType, trackEventXid);
        return false;
    },
}

const routes = (!['prometheus.portal', 'prometheus.portal.geotab'].includes(process.env.VUE_APP_PACKAGE)) ? [] : [
    {
        path: 'md/:pathMatch(.*)?',
        name: consts.routerNames.md.main,
        redirect: {
            name: consts.routerNames.md.fleet.main,
        },
        meta: {
            mainRouteName: consts.routerNames.md.main,
            pageClass: 'unit-md-page',
            layers: consts.defaultSettingsLayers,
            setRoute: defaultSetRoute,
            routeParams,
        },
        component: () => import('@/views/prometheus/portal/MdPage.vue'),
        children: [
            {
                path: 'fleet/:groupId(\\d+)?',
                name: consts.routerNames.md.fleet.main,
                meta: {
                    mainRouteName: consts.routerNames.md.main,
                    pageClass: 'unit-md-page',
                    layers: consts.defaultSettingsLayers,
                    setRoute: defaultSetRoute,
                },
                component: () => import('@/components/units/info/MD/UnitsInfo_md.vue'),
                children: [
                    {
                        path: ':widget',
                        name: consts.routerNames.md.fleet.widget,
                        meta:{
                            pageClass: 'unit-md-page unit-md-page__full',
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.fleet.main,
                        },
                    }
                ]
            },
            {
                path: 'vision',
                name: consts.routerNames.md.vision.main,
                meta: {
                    mainRouteName: consts.routerNames.md.main,
                    parentRouteName: consts.routerNames.md.vision.main,
                    pageClass: 'unit-md-page',
                    layers: consts.defaultSettingsLayers,
                    setRoute: defaultSetRoute,
                },
                props: {
                },
                components: {
                    default: () => import("@/components/md/vision/MDVision.vue")
                },
                children: [
                    {
                        path: 'cameras',
                        name: consts.routerNames.md.vision.cameras.main,
                        meta: {
                            list: 'GroupsList_md',
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.vision.main,
                        },
                        props: {
                            default: (route) => ({
                                groupId: route?.params?.groupId
                            })
                        },
                        components: {
                            default: () => import("@/components/md/vision/cameras/MDVision_cameras.vue")
                        },
                        children: [
                            {
                                path: ':groupId(\\d+)',
                                name: consts.routerNames.md.vision.cameras.groupId.main,
                                meta: {
                                    mainRouteName: consts.routerNames.md.main,
                                    parentRouteName: consts.routerNames.md.vision.cameras.main,
                                },
                            },
                        ]
                    },
                    {
                        path: 'driver-scorecard',
                        name: consts.routerNames.md.vision.driverScorecard.main,
                        meta: {
                            //list: 'GroupsList_md',
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.vision.main,
                        },
                        props: {
                        },
                        components: {
                            default: () => import("@/components/md/MDDriverScorecard.vue")
                        },
                    },
                ]
            },
            {
                path: 'xcool',
                name: consts.routerNames.md.xcool.main,
                meta: {
                    // list: 'GroupsList_md_xcool',
                    mainRouteName: consts.routerNames.md.main,
                    parentRouteName: consts.routerNames.md.xcool.main,
                    pageClass: 'unit-md-page',
                    layers: consts.defaultSettingsLayers,
                    setRoute: defaultSetRoute,
                },
                props: {
                    default: (route) => ({
                        groupId: route?.params?.groupId
                    })
                },
                components: {
                    default: () => import("@/components/md/xCool/MDXCool.vue")
                },
                children: [
                    {
                        path: ':groupId(\\d+)?/reefers',
                        name: consts.routerNames.md.xcool.reefers.main,
                        meta: {
                            list: 'GroupsList_md_xcool',
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.xcool.main,
                        },
                        props: {
                            default: (route) => ({
                                groupId: route?.params?.groupId
                            })
                        },
                        components: {
                            default: () => import("@/components/md/xCool/MDXCool_reefers.vue")
                        },
                    },
                    {
                        path: 'green-see',
                        name: consts.routerNames.md.xcool.greenSee.main,
                        redirect: to => {
                            return {
                                name: consts.routerNames.md.xcool.greenSee.date,
                                params: {
                                    ...to.params,
                                    date: to?.params?.date || store.getters.getDateToday,
                                    dateTo: to?.params?.dateTo
                                },
                                query: to.query
                            }
                        },
                        meta: {
                            mainRouteName: consts.routerNames.md.main,
                            parentRouteName: consts.routerNames.md.xcool.main,
                            pageClass: 'unit-md-page unit-md-page__xcoo-green-see',
                            showMap: true,
                            unitTracking: false,
                            layers: {
                                ...consts.defaultSettingsLayers,
                                units: {visible: true, showInList: true, showLayer: true},
                                notifications: {visible: true, showInList: true, showLayer: true},
                            },
                        },
                        props: {
                            default: (route) => {
                                return {
                                    groupId: route?.params?.groupId,
                                    tripId: route?.params?.tripId
                                }
                            }
                        },
                        components: {
                            default: () => import("@/components/md/xCool/GreenSee/MDXCool_greenSee.vue")
                        },
                        children: [
                            {
                                path: ':date(\\d{4}-\\d{2}-\\d{2})/:dateTo(\\d{4}-\\d{2}-\\d{2})?',
                                name: consts.routerNames.md.xcool.greenSee.date,
                                meta: {
                                    mainRouteName: consts.routerNames.md.main,
                                    parentRouteName: consts.routerNames.md.xcool.greenSee.main,
                                },
                                components: {
                                    default: () => import("@/components/routeView.vue")
                                },
                                children: [
                                    {
                                        path: ':tripId',
                                        name: consts.routerNames.md.xcool.greenSee.tripId,
                                        meta: {
                                            mainRouteName: consts.routerNames.md.main,
                                            parentRouteName: consts.routerNames.md.xcool.greenSee.date,
                                            blockingRoutesTransitionFromOutside: true,
                                            pageClass: 'unit-md-page unit-md-page__xcoo-green-see unit-md-page__xcoo-green-see__trip',
                                            layers: {
                                                ...consts.defaultSettingsLayers,
                                                greensee_tracks: {visible: true, showInList: true, showLayer: true},
                                            },
                                        },
                                        props: {
                                            default: (route) => {
                                                return {
                                                    tripId: route?.params?.tripId
                                                }
                                            }
                                        },
                                        components: {
                                            default: () => import("@/components/md/xCool/GreenSee/MDXCool_greenSee_trip")
                                        },
                                        children: [
                                            {
                                                path: ':unitId(\\d+)/:timeFrom(\\d+)/:timeTo(\\d+)',
                                                name: consts.routerNames.md.xcool.greenSee.track,
                                                meta: {
                                                    layers: {
                                                        ...consts.defaultSettingsLayers,
                                                        greensee_tracks: {visible: true, showInList: true, showLayer: true},
                                                        notifications: {visible: true, showInList: true, showLayer: true},
                                                    },
                                                },
                                                components: {
                                                },
                                            },
                                            {
                                                path: 'graph/:unitId(\\d+)/:timeFrom(\\d+)/:timeTo(\\d+)',
                                                name: consts.routerNames.md.xcool.greenSee.graph,
                                                meta: {
                                                    pageClass: 'unit-md-page unit-md-page__xcoo-green-see unit-md-page__xcoo-green-see__graph',
                                                },
                                                components: {
                                                },
                                            },
                                        ]
                                    },
                                ],
                            },
                        ]
                    },
                ]
            },
        ]
    },
];

export default routes;